module.exports = {"TXTCLI_City":{"id":"TXTCLI_City","defaultMessage":"City","flags":["TRACK"],"track":"City"}}